import { render, staticRenderFns } from "./sustainabilityCard.vue?vue&type=template&id=a81b7500&scoped=true"
import script from "./sustainabilityCard.vue?vue&type=script&lang=js"
export * from "./sustainabilityCard.vue?vue&type=script&lang=js"
import style0 from "./sustainabilityCard.vue?vue&type=style&index=0&id=a81b7500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81b7500",
  null
  
)

export default component.exports